import {
  Metrics,
  MetricValue,
  MetricValueLevel,
  MetricValues,
} from "calculation/metric";
import { ParameterValues } from "calculation/parameter";
import { ScenarioDto } from "dtos/dtos";
import * as calculators from "calculation/metricCalculators";
import { CalculationState } from "state/state";

export async function calculate(
  metrics: Metrics,
  metricValues: MetricValues,
  parameterValues: ParameterValues,
  scenario: ScenarioDto
): Promise<CalculationState> {
  metricValues.aggregateZoneGde(metrics);
  let metricCalculators = [
    calculators.wohnflEinw,
    calculators.popDec,
    calculators.popInc,
    calculators.popTh,
    calculators.populationVariation,
    calculators.populationTemporary,
    calculators.populationPending,
    calculators.populationRelevant,
    calculators.areaRealizedCovered,
    calculators.varUezFinal,
    calculators.avgBuildingHeight,
    calculators.avgBuildingHeightFinal,
    calculators.varHabitationRatioFinal,
    calculators.areaPotCovered,
    calculators.areaPotUncovered,
    calculators.populationPotCovered,
    calculators.populationPotTotalCovered,
    calculators.populationPotUncovered,
    calculators.populationCapacityCovered,
    calculators.populationCapacityUncovered,
    calculators.populationCapacity,
  ];

  const messages: calculators.MetricCalculationResultMessage[] = [];

  for (const district of scenario.districts) {
    for (const zoneGde of district.zonesGde) {
      for (const calculator of metricCalculators) {
        const level: MetricValueLevel = {
          name: "districtZoneGde",
          bfsNr: scenario.bfsNr,
          bfsNr1999: district.bfsNr1999,
          zonTypGde: zoneGde.zonTypGde,
          zonTypKt: zoneGde.zonTypKt,
          zonTypPbg: zoneGde.zonTypPbg,
        };
        const result = calculator(metricValues, parameterValues, level);

        messages.push(...result.messages);

        if (result.value !== undefined) {
          metricValues.addValue(new MetricValue(result.value, result.context));
        }
      }
    }
  }

  metricValues.aggregate(metrics, "districtResidential");
  metricValues.aggregate(metrics, "district");
  metricValues.aggregate(metrics, "zonTypPbg");

  metricCalculators = [
    calculators.aPopulationActual,
    calculators.populationHist,
    calculators.lBuildingAreaDemandActual,
    calculators.mBuildingAreaDemandExpected,
    calculators.oBuildingAreaDemandComparison,
    calculators.populationKgwrFinal,
    calculators.populationCorrection,
    calculators.bPopulationCapacityTotal,
    calculators.cPopulationGrowth,
    calculators.pVarFactorRp,
    calculators.qPopulationFuture,
    calculators.rPopulationNewZonesDemand,
    calculators.compensation,
  ];

  for (const district of scenario.districts) {
    for (const calculator of metricCalculators) {
      const level: MetricValueLevel = {
        name: "district",
        bfsNr: scenario.bfsNr,
        bfsNr1999: district.bfsNr1999,
      };
      const result = calculator(metricValues, parameterValues, level);

      messages.push(...result.messages);

      if (result.value !== undefined) {
        metricValues.addValue(new MetricValue(result.value, result.context));
      }
    }
  }

  metricValues.aggregate(metrics, "municipality");

  metricCalculators = [
    calculators.dPopulationGrowthPercent,
    calculators.ePopulationGrowthAnnual,
    calculators.fPopulationGrowthAnnualPercent,
  ];

  for (const calculator of metricCalculators) {
    const level: MetricValueLevel = {
      name: "municipality",
      bfsNr: scenario.bfsNr,
    };
    const result = calculator(metricValues, parameterValues, level);

    messages.push(...result.messages);

    if (result.value !== undefined) {
      metricValues.addValue(new MetricValue(result.value, result.context));
    }
  }

  metricValues.aggregate(metrics, "canton");

  return {
    metricValues: metricValues,
    parameterValues: parameterValues,
    metricCalculationResultMessages: messages,
  };
}
